import { useNavigate } from "react-router-dom";
import { Plus, ChevronRight } from "lucide-react";
import { useRoutines } from "@/hooks/useApi";

export default function RoutinesPage() {
  const navigate = useNavigate();
  const { data: routines = [], isLoading } = useRoutines();

  if (isLoading) return <div className="p-4 text-zinc-500 text-sm">Loading…</div>;

  return (
    <div className="p-4 space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Routines</h1>
        <button
          onClick={() => navigate("/routines/new")}
          className="flex items-center gap-1 rounded-lg bg-zinc-800 px-3 py-2 text-sm hover:bg-zinc-700 transition-colors"
        >
          <Plus className="h-4 w-4" />
          New
        </button>
      </div>

      {routines.length === 0 ? (
        <p className="text-sm text-zinc-500">No routines yet.</p>
      ) : (
        <ul className="space-y-2">
          {routines.map((r) => (
            <li key={r.id}>
              <button
                onClick={() => navigate(`/routines/${r.id}`)}
                className="flex w-full items-center justify-between rounded-lg border border-zinc-800 p-3 hover:bg-zinc-900 transition-colors"
              >
                <div className="text-left">
                  <p className="font-medium text-sm">{r.name}</p>
                  {r.description && (
                    <p className="text-xs text-zinc-500 mt-0.5 truncate">{r.description}</p>
                  )}
                </div>
                <ChevronRight className="h-4 w-4 text-zinc-600 shrink-0" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
